export default __webpack_public_path__ + "static/social-default-image-977eda31e362baaf1cd41f01d68518dd.png";